<div class="row">
  <div class="col">
    <img src="../../assets/images/b5.jpeg" alt="" width="100%">
  </div>
</div>
